import React from 'react';
import { Grid } from '@mui/material';

import {
	DateField,
	ModuleSearchField,
	NumberTextField,
	SearchSelectField,
	SimpleTextField,
	useSettings,
	useUserData,
	Utils
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ActivitiesDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	// const checkActivity = (_event, value) => {
	// 	if (!value) return;
	// 	// "Conclusa" id:3, order:4
	// 	if (value.acst_id === 3)
	// 		dispatch(
	// 			showFastAddDialog({
	// 				model: { wore_acti_uid: props.acti_uid },
	// 				module: 'workreports'
	// 			})
	// 		);
	// };

	function updateDates(newStatus) {
		if (newStatus?.acst_id === 2) props.sendChange('acti_d_start', Utils.today());
		if (newStatus?.acst_id === 3 || newStatus?.acst_id === 4) props.sendChange('acti_d_end', Utils.today());
	}

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="acti_title"
					label={t('DETAILS_ACTIVITIES_FIELD_TITLE')}
					value={props.model.acti_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="acti_acst_id"
					label={t('DETAILS_ACTIVITIES_FIELD_STATUS')}
					systable="activities_statuses"
					value={props.model.acti_acst_id}
					// afterChange={checkActivity}
					afterChange={updateDates}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="acti_acty_id"
					label={t('DETAILS_ACTIVITIES_FIELD_TYPE')}
					systable="activities_types"
					value={props.model.acti_acty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* COMPANY */}
				<ModuleSearchField
					name="acti_comp_uid"
					label={t('DETAILS_ACTIVITIES_FIELD_COMPANY')}
					module="companies"
					uid={props.model.acti_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EXTERNAL CONTACT */}
				<ModuleSearchField
					name="acti_peop_uid"
					label={t('DETAILS_ACTIVITIES_FIELD_PERSON')}
					module="people"
					uid={props.model.acti_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="acti_user_assigned_uid"
					label={t('DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.acti_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="acti_user_assigned_2_uid"
					label={t('DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.acti_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE FROM */}
				<DateField
					name="acti_d_from"
					label={t('DETAILS_ACTIVITIES_FIELD_DATE_FROM')}
					value={props.model.acti_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="acti_d_to"
					label={t('DETAILS_ACTIVITIES_FIELD_DATE_TO')}
					value={props.model.acti_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE START */}
				<DateField
					name="acti_d_start"
					label={t('DETAILS_ACTIVITIES_FIELD_DATE_START')}
					value={props.model.acti_d_start}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE END */}
				<DateField
					name="acti_d_end"
					label={t('DETAILS_ACTIVITIES_FIELD_DATE_END')}
					value={props.model.acti_d_end}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ lg: 3, xs: 12 }}>
				{/* TOT HOURS */}
				<NumberTextField
					name="acti_length_hours"
					label={t('DETAILS_ACTIVITIES_FIELD_LENGTH_HOURS')}
					value={props.model.acti_length_hours}
					isEdit={props.isEdit}
					measureUnit="h"
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ lg: 3, xs: 12 }}>
				{/* TOT MINUTES */}
				<NumberTextField
					name="acti_length_minutes"
					label={t('DETAILS_ACTIVITIES_FIELD_LENGTH_MINUTES')}
					value={props.model.acti_length_minutes}
					isEdit={props.isEdit}
					measureUnit="min"
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
